import LogoGrowz from '../assets/images/growzlogo.svg';
import LogoAisle from '../assets/images/aislelogo.svg';
import AisleConnect from '../assets/images/connectaisle.svg';
import GrowzConnect from '../assets/images/connectgrowz.svg';

export const productSwitchConfig = {
  aisle: {
    title: 'Aisle Dominator',
    logo: LogoAisle,
    link: '/aisle/market-stream',
    svg: LogoAisle,
    para: 'Connect Amazon account and create your first Aisle dominator now! Increase your Category ownership and secure a desired aisle with our keywords.',
    bgimage: AisleConnect,
  },
  growz: {
    title: 'Growz Engine',
    logo: LogoGrowz,
    link: '/growz/dashboard',
    svg: LogoGrowz,
    para: 'Grow your Amazon business with goal-oriented strategies that address all of your needs. Remove the guesswork from your business.',
    bgimage: GrowzConnect,
  },
};
